import { createSlice } from 'utils/@reduxjs/toolkit';
import { StemExtensionsDataState } from './types';
import { reducers } from './reducers';

export const initialState: StemExtensionsDataState = {
  isLoading: false,
  error: null,
  data: { items: [], filterAttributes: [], total: 0 },
};

const slice = createSlice({
  name: 'stemExtensionsData',
  initialState,
  reducers,
});

export const { actions: stemExtensionsDataActions } = slice;
export const { reducer: stemExtensionsDataReducer } = slice;
